import React from 'react';

const HostParty = () => {
  return (
    <div id="host-party" className="container">
      <div className="content">
        <div className="mini-content">
          <h2>Host a party: T-Shirt Birthday Parties & More</h2>
          <img src="./img/host-party.jpg" alt="" className="img-space"/>
          <div className="max-width-85">
            <h3> Need a fun, different and positive way to celebrate your kids birthday party?</h3>
            <p>Our parties include one-two hours of fun activities from beginning to end. We'll go through the entire process of making a customized T-shirt with a positive message. At the same time kids will not only be engaged in the T-Shirt making process, but also will be taught the basics of anti-bullying and how to stand up to it.</p>
            <h3>Here's what is included in our standard package ($600):</h3>
            <ul>
              <li>We come to your place or event venue</li>
              <li>2-3 Coaches will manage all event activities</li>
              <li>Pizza & spring water for kids </li>
              <li>Customized T-shirts  </li>
              <li>Anti-bully lesson</li>
              <li>Max 10 children ($25 for each additional child)</li>
              <li>Offered everyday of the week (9am to 9pm) </li>
            </ul>
            <p>We also offer customized cake and decorations at an additionnal fee.</p>
          </div>
          <div className="button-wrapper">
            <a href="" data-leadbox-popup="145515473f72a2:10e8a98c4f46dc" data-leadbox-domain="tecniquo.lpusercontent.com" className="button">LEARN MORE ABOUT OUR PARTY PACKAGES</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HostParty;



// WEBPACK FOOTER //
// ./src/components/home/HostParty.js